/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RECORDING_STATUS } from '../../../../constants/constants';

/**
 * Class representing the recorder player.
 * @extends Component
 * */
class RecorderPlayer extends Component {

  static propTypes = {
    recordBlob: PropTypes.shape({}),
    resetAudio: PropTypes.func.isRequired,
    setAudio: PropTypes.func.isRequired,
    setStatus: PropTypes.func.isRequired,
    status: PropTypes.string.isRequired,
    updateProgress: PropTypes.func.isRequired,
  };

  static defaultProps = {
    recordBlob: null
  };

  audio = React.createRef();

  /**
   * Triggers the audio playing event.
   * */
  onPlaying = () => {
    const { updateProgress } = this.props;

    updateProgress();
  };

  /**
   * Triggers the audio loaded event.
   * */
  onAudioLoaded = () => {
    const { setAudio } = this.props;

    setAudio(this.audio);
  };

  /**
   * Triggers the audio ended event.
   * */
  onAudioEnded = () => {
    const { resetAudio, setStatus } = this.props;

    setStatus(RECORDING_STATUS.RECORDED);
    resetAudio();
  };

  render() {
    const { recordBlob, status } = this.props;

    if ((recordBlob) && (status === RECORDING_STATUS.RECORDED
      || status === RECORDING_STATUS.PLAYING)) {
      const url = URL.createObjectURL(recordBlob);
      const { type } = recordBlob;

      if( (url) && (type) ){        

        return (
          <audio
            onEnded={this.onAudioEnded}
            onLoadedMetadata={this.onAudioLoaded}
            onPlaying={this.onPlaying}
            ref={(node) => { this.audio = node; }}
          >
            <source src={url} type={type} />
          </audio>
        );    
      }
    
    }

    return null;
  }

}

export default RecorderPlayer;



// WEBPACK FOOTER //
// ./src/messages/recorder/recorder-content/recorder-player/recorder-player.component.js